import get from "lodash/get";
import React from "react";
import { FieldArray } from "react-final-form-arrays";
import { withReactFinalTable } from "./FinalTableContext";

const defaultRender = (item, column) => get(item, column.key);

// assumes inside a <Form with valies in the form of {rows: []}>

function TableBody({ columns = [], projection, map, onRowClick }) {
  if (!Array.isArray(projection)) {
    return <tbody />;
  }

  const className = onRowClick ? "has-action" : "";

  return (
    <tbody>
      <FieldArray name="rows">
        {({ fields }) => (
          <>
            {fields.map((name, index) => (
              <tr key={name} className={className}>
                {columns.map(({ render = defaultRender, ...column }) => (
                  <td key={column.key} style={column.style}>
                    {render(fields.value[index], column, index, name)}
                  </td>
                ))}
              </tr>
            ))}
          </>
        )}
      </FieldArray>
    </tbody>
  );
}

export default withReactFinalTable(TableBody);
